import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { BaseService } from './base.service';
import { MessageService } from 'primeng/api';
import { CleApiEntite } from '../entites/cle-api';

@Injectable({ providedIn: 'root' })
export class CleApiService extends BaseService {
  private baseApiUrl = environment.apiBaseUrl + 'auth/cles-api';

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router,
    public messageService: MessageService
  ) {
    super(messageService, router);
  }

  /**
   * Obtient la liste de toutes les clés API
   * @returns Observable contenant la liste des clés API
   */
  public obtenirClesApi(): Observable<CleApiEntite[]> {
    return this.http.get<CleApiEntite[]>(this.baseApiUrl)
      .pipe(catchError((error) => this.handleError(error)));
  }

  /**
   * Obtient une clé API spécifique
   * @param id ID de la clé
   * @returns Observable contenant la clé API
   */
  public obtenirCleApi(id: number): Observable<CleApiEntite> {
    return this.http.get<CleApiEntite>(`${this.baseApiUrl}/${id}`)
      .pipe(catchError((error) => this.handleError(error)));
  }

  /**
   * Ajoute une nouvelle clé API
   * @param cle Données de la clé à créer
   * @returns Observable contenant la clé créée (avec valeurDechiffree)
   */
  public creerCleApi(cle: Partial<CleApiEntite>): Observable<CleApiEntite> {
    return this.http.post<CleApiEntite>(this.baseApiUrl, JSON.stringify(cle), this.httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  /**
   * Modifie une clé API existante
   * @param id ID de la clé
   * @param cle Nouvelles données
   * @returns Observable contenant le message de succès
   */
  public modifierCleApi(id: number, cle: Partial<CleApiEntite>): Observable<any> {
    return this.http.put<any>(`${this.baseApiUrl}/${id}`, JSON.stringify(cle), this.httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  /**
   * Régénère une clé API existante
   * @param id ID de la clé à régénérer
   * @returns Observable contenant la clé avec la nouvelle valeurDechiffree
   */
  public regenererCleApi(id: number): Observable<CleApiEntite> {
    return this.http.post<CleApiEntite>(`${this.baseApiUrl}/${id}/regenerer`, null, this.httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  /**
   * Supprime une clé API
   * @param id ID de la clé à supprimer
   * @returns Observable contenant le message de succès
   */
  public supprimerCleApi(id: number): Observable<any> {
    return this.http.delete<any>(`${this.baseApiUrl}/${id}`)
      .pipe(catchError((error) => this.handleError(error)));
  }
}

